import React from "react";
import UserDetails from "./userDetails";
import { getAllUserReports } from "../actions";
import { useDispatch, useSelector } from "react-redux";
import ReportedUserTable from "../../../components/reportManagement/ReportedUserTable";

/**
 * @function User
 * @description for User
 * @returns JSX for User
 */
const User = ({
  selectedUserId,
  selectedIdHandler,
  setUserStatus,
  userStatus,
}) => {
  const { pageNo, limit, searchKey, sortOrder, sortBy } = useSelector(
    (state) => state.ReportReducer.user.reportedUsers
  );
  const dispatch = useDispatch();

  React.useEffect(() => {
    dispatch(getAllUserReports());
  }, [pageNo, limit, searchKey, sortOrder, sortBy, userStatus]);

  return (
    <div>
      {selectedUserId.length === 0 ? (
        <ReportedUserTable selectedIdHandler={selectedIdHandler} />
      ) : (
        <UserDetails
          selectedUserId={selectedUserId}
          setUserStatus={setUserStatus}
        />
      )}
    </div>
  );
};

export default User;
